import { ClipLoader } from "react-spinners";

import { useGetAboutUs, useUpdateAboutUs } from "../../apis";
import { AboutUsForm, AboutUsFormValues } from "../../components";

import styles from "./AboutUs.module.scss";

const ABOUT_US_FORM_ID = "aboutUs-form-id";

const AboutUs = () => {
  const { aboutUsData, isLoading } = useGetAboutUs();

  const updateAboutUs = useUpdateAboutUs();

  const handleFormSubmit = (formData: AboutUsFormValues) => {
    updateAboutUs.mutate(formData);
  };

  return (
    <div className={styles.aboutUs}>
      {!isLoading && aboutUsData ? (
        <AboutUsForm
          formId={ABOUT_US_FORM_ID}
          onSubmit={handleFormSubmit}
          defaultValues={aboutUsData}
          isLoadingUpdate={updateAboutUs.isLoading}
        />
      ) : (
        <div className={styles.aboutUs_loader}>
          <ClipLoader size={50} color="#fb3973" />
        </div>
      )}
    </div>
  );
};

export default AboutUs;
